/**
 * Labstep
 *
 * @module grid/Index/coldefs/actionMenu
 * @desc Column Definition for actionMenu
 */

import classNames from 'classnames';
import { DataGrid } from 'labstep-web/core/DataGrid';
import type {
  ColDef,
  ColDefParams,
} from 'labstep-web/core/DataGrid/types';
import type { Entity } from 'labstep-web/models/entity.model';
import styles from './styles.module.scss';

const colDefActionMenu = <T extends Entity>(
  action: (params: ColDefParams<T>) => JSX.Element,
): ColDef<T> => ({
  colId: 'action_menu',
  maxWidth: 20,
  pinned: 'left',
  cellRenderer: DataGrid?.CellRenderer?.ActionMenu as any,
  cellRendererParams: (params) => ({
    props: {
      action: action(params),
    },
  }),
  headerClass: 'no-border',
  cellClass: classNames('no-border', styles.cell),
  lockPosition: true,
  valueGetter: () => '',
});

export default colDefActionMenu;
